import { NBSP_STRING } from '../constants/common';

const isEmptyContentEditable = (element) => {
  const { innerText } = element;
  const hasOnlyBreakOrSpace = innerText === '\n' || innerText === NBSP_STRING;

  return !innerText || (innerText.length === 1 && hasOnlyBreakOrSpace);
};

export default isEmptyContentEditable;
